import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientsComponent } from './clients-list/clients.component';
import { ClientsAddComponent } from './clients-add/clients-add.component';
import { ClientViewComponent } from './client-view/client-view.component';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbNav, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalModule } from '../modal/modal.module';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { PipesModule } from '../pipes/pipes.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { SharedComponentsModule } from '../shared-components-module/shared-components.module';
import { ClientsEditComponent } from './clients-edit/clients-edit.component';
import { CriminalGridModule } from '../decision-grid/criminal-grid.module';
import { PaymentModule } from '../shared-components-module/payments/payment.module';
import { ScoringModelMgrComponent } from './scoring-model-mgr/scoring-model-mgr.component';

const routes: Routes = [
  {path: 'clients', component: ClientsComponent},
  {path: 'clients/new', component: ClientsAddComponent},
  {path: 'clients/edit/:id', component: ClientsEditComponent},
  {path: 'clients/review/:client', component: ClientViewComponent}
];

@NgModule({
  declarations: [
    ClientsComponent,
    ClientsAddComponent,
    ClientViewComponent,
    ClientsEditComponent,
    ScoringModelMgrComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PaymentModule,
    NgbModule,
    NgbdModalModule,
    AngularEditorModule,
    PipesModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    SharedComponentsModule,
    CriminalGridModule,
    RouterModule.forRoot(routes),
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      preventDuplicates: false,
    }), // ToastrModule added
    PaymentModule,
    NgbNavModule
  ]
})



export class ClientsModule { }
